import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CalendarYearModel, CalendarMonthModel, CalendarModel, MONTH } from 'src/app/core/models/calendar.model';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {

  private activeViewMonth: number;
  public activeViewYear: number;

  @Input() calendar: CalendarModel;
  @Input() activeDay: number;

  @Output() public selectDate = new EventEmitter<{year: number, month: number, day: number}>();

  @Input() set activeYear(y: number) {
    this.activeViewYear = y;
    this.setViewMonth();
  }

  @Input() set activeMonth(m: number) {
    this.activeViewMonth = m;
    this.setViewMonth();
  }

  public viewMonth: CalendarMonthModel;

  public weekDays = [ 'D', 'S', 'T', 'Q', 'Q', 'S', 'S' ];
  public month = '';
  public initialDay: number;

  ngOnInit(): void {
    this.setViewMonth();
  }

  public setViewMonth(): void {
    this.month = MONTH[this.activeViewMonth];
    this.initialDay = this.activeDay;


    this.calendar.years.forEach((y: CalendarYearModel, yi: number) => {
      if (y.year === this.activeViewYear) {
        y.months.forEach((m: CalendarMonthModel, mi: number) => {
          if (m.month === this.activeViewMonth) {
            this.viewMonth = JSON.parse(JSON.stringify(this.calendar.years[yi].months[mi]));
            this.completeEdges(yi, mi);
            return;
          }
        });
      }
    });
  }

  public completeEdges(yi: number, mi: number): void {
    const viewMonthFirstWeekLen = this.calendar.years[yi].months[mi].weeks[0].days.length;
    const viewMonthLastWeekLen = this.calendar.years[yi].months[mi].weeks[this.calendar.years[yi].months[mi].weeks.length - 1].days.length;
    const viewMonthLastWeekIdx = this.calendar.years[yi].months[mi].weeks.length - 1;
    let nextMonthIdx = mi + 1;
    let lastMonthIdx = mi - 1;
    let nextYearIdx = yi;
    let lastYearIdx = yi;
    if (mi === 0) {
      lastMonthIdx = 11;
      lastYearIdx = yi - 1;
    }
    if (mi === 11) {
      nextMonthIdx = 0;
      nextYearIdx = yi + 1;
    }
    const firstWeekEdge = this.calendar.years[lastYearIdx].months[lastMonthIdx].weeks.length - 1;
    if (viewMonthFirstWeekLen < 7) {
      const iDays = JSON.parse(JSON.stringify(this.calendar.years[lastYearIdx].months[lastMonthIdx].weeks[firstWeekEdge].days));
      iDays.forEach(day => day.notActive = true);
      const d = iDays.concat(this.calendar.years[yi].months[mi].weeks[0].days);
      this.viewMonth.weeks[0].days = d;
    }
    if (viewMonthLastWeekLen < 7) {
      const iDays = JSON.parse(JSON.stringify(this.calendar.years[nextYearIdx].months[nextMonthIdx].weeks[0].days));
      iDays.forEach(day => day.notActive = true);
      this.viewMonth.weeks[viewMonthLastWeekIdx].days = this.viewMonth.weeks[viewMonthLastWeekIdx].days.concat(iDays);
    }
  }

  public clickDay(weekDay: { notActive: boolean; day: number; }) {
    if (weekDay.notActive) {
      if (weekDay.day < 10 ) { this.activeViewMonth++; }
      if (weekDay.day > 20 ) { this.activeViewMonth--; }
    }
    this.initialDay = weekDay.day;
    this.selectDate.emit({
      year: this.activeViewYear,
      month: this.activeViewMonth,
      day: weekDay.day
    });
  }

  public clickBack() {
    if (this.activeViewMonth <= 0) {
      return;
    }
    this.activeViewMonth--;
    this.month = MONTH[this.activeViewMonth];
    this.selectDate.emit({
      year: this.activeViewYear,
      month: this.activeViewMonth,
      day: this.initialDay
    });
  }

  public clickNext() {
    if (this.activeViewMonth >= 11) {
      return;
    }
    this.activeViewMonth++;
    this.month = MONTH[this.activeViewMonth];
    this.selectDate.emit({
      year: this.activeViewYear,
      month: this.activeViewMonth,
      day: this.initialDay
    });
  }


}
